import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { PrismicDocumentTypes, PrismicPage } from '../../prismic';
import { fetchPrismicPage } from '../../redux/pages';
import { PrismicSingle } from './prismic_single';

interface OwnProps {
  type: PrismicDocumentTypes;
  render: (page: PrismicPage) => JSX.Element;
}

const PrismicSingleLoader = (props: OwnProps) => {
  const { type, render } = props;
  const dispatch = useDispatch();

  useFrontload(`PrismicSingleLoader_${type}`, async () => {
    await dispatch(fetchPrismicPage(type));

    return true;
  });

  return <PrismicSingle render={render} />;
};

export default PrismicSingleLoader;
